var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArchive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1M3 12.625a.376.376 0 0 1-.375.375h-.25A.376.376 0 0 1 2 12.625v-.25c0-.206.169-.375.375-.375h.25c.206 0 .375.169.375.375zM4 10H1V5h3zm0-6H1V3h3zm6-3H7c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1M9 12.625a.376.376 0 0 1-.375.375h-.25A.376.376 0 0 1 8 12.625v-.25c0-.206.169-.375.375-.375h.25c.206 0 .375.169.375.375zM10 10H7V5h3zm0-6H7V3h3zm6-3h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1m-1 11.625a.376.376 0 0 1-.375.375h-.25a.376.376 0 0 1-.375-.375v-.25c0-.206.169-.375.375-.375h.25c.206 0 .375.169.375.375zM16 10h-3V5h3zm0-6h-3V3h3z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArchive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/archive.svg";